export default function() {
    return {
        apiUrl: process.env.VUE_APP_API_URL,
        baseUrl: process.env.VUE_APP_BASE_URL,
        agencyId: this.$store.state.user?.agency?.id,
        product: null,
        preloadedTrip: null,
        step: 1,
        steps: {
            1: {
                title: 'Escolha as trips',
                progress: 25,
            },
            2: {
                title: 'Formas de pagamento',
                progress: 50
            },
            3: {
                title: 'Pagamento',
                progress: 75
            },
            4: {
                title: 'Concluído',
                progress: 100
            }
        },
        trips: [
            {
                trip: '',
                title: '',
                interval: {},
                duration: 0
            }
        ],
        quantity: 1,
        creditCardNumber: null,
        creditCardName: null,
        creditCardExpDate: null,
        creditCardCode: null,
        invalidCard: false,
        availableInstallments: [],
        installments: 1,
        selectingDate: null,
        paymentMethod: 1,
        minDate: new Date(),
        boost: {
            quantity: 1
        },
        showCheckoutError: false,
        checkoutId: null,
        pixTimerId: null,
        pixCodeCopied: false,
        pixData: {
            qrCode: null,
            code: null
        },
        invalidCardNumberMessage: '',
        invalidCardNameMessage: '',
        invalidCardExpDateMessage: '',
        invalidCardCvvMessage: '',
    }
}
